import React from 'react';
export default function SummaryTab() {
  return (
    <div className="alert alert-info mt-4">College summary and profile coming soon.</div>
  );
}